import React from "react";
import { Modal, Select, DatePicker,  Form } from "antd";
import {Link } from "react-router-dom";
import useFetch from "../../commons/useFetch";
function PopupBooking({ isModalVisible, setIsModalVisible}) {
  const handleCancel = () => setIsModalVisible(false);

  const {data : hotels}=useFetch('https://610ec1597f793c00174195b7.mockapi.io/api/hotels/')
  const { Option } = Select;
  const dateFormat = "DD-MM-YYYY";

  const onFinish = (values) => {
    console.log('succes:', values);
  };

  const onFinishFailed = (errorInfo) => {
    console.log('Failed:', errorInfo);
  };
  return (
    <div className="modalBox ">
      <Modal
        destroyOnClose={true}
        title="ĐẶT PHÒNG"
        className="bookingNowModal modalStyle"
        visible={isModalVisible}
        onCancel={handleCancel}
        footer={null}
      >
        <Form
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}>
          <p class="titlePopup">
            Đặt phòng với SOJO và <span>nhận mức giá tốt nhất!</span>
          </p>
          <Form.Item className="formInput"
            label="EMAIL HOẶC SỐ ĐIỆN THOẠI"
            name="email"
          >
            <div className="formLocation">
              <Select placeholder="Chọn khách sạn">
                <Option>Tất cả khách sạn</Option>
                {hotels.map((option) => (
                  <Option value={option.code} key={option.code}>
                    {option.name}
                  </Option>
                ))}
              </Select>
            </div>
          </Form.Item>
          <Form.Item className="formInput password"
            label="Thời gian"
            name="email"
          >
            <div className="row ">
              <div className="col-lg-6 col-12 date">
                <DatePicker
                  //   onChange={(date, dateString) =>
                  //     props.onchangeFromDate(dateString)
                  //   }
                  name="arrivalDate"
                  placeholder="Từ ngày"
                  format={dateFormat}
                />
              </div>
              <div className="col-lg-6 col-12 date">
                <DatePicker
                  //   onChange={(date, dateString) =>
                  //     props.onchangeToDate(dateString)
                  //   }
                  name="departureDate"
                  placeholder="Đến ngày"
                  format={dateFormat}
                />
              </div>
            </div>
          </Form.Item>
          <div className="endowChoose">
            <Link to="/">Chọn ưu đãi</Link>
          </div>
          <Form.Item className="btnModal">
            <button className="btnStyle" >
              Enter
            </button>
          </Form.Item>
        </Form>
      </Modal>
    </div>
  );
}
export default PopupBooking;
